import { useMemo, useState } from "react";

import { KSemiText700, Loading } from "@components";
import { useFetchInfoTypesService } from "@hooks";
import { useListInfoType } from "@store";
import { EFileSort, ICardHospitalizationsRes } from "@types";
import { HospitalizationItem, SortItem } from "../item";
import { CustomSpaceList, WrapperCardList } from "../share-component";
import { getQuery } from "@utils/card";

const renderCardItems = (filteredCards: ICardHospitalizationsRes[]) => {
  return filteredCards.map((card: ICardHospitalizationsRes) => (
    <HospitalizationItem key={card._id} card={card} />
  ));
};

export const ListHospitalizations = () => {
  const { hospitalizationsList = [], isLoadingList } = useListInfoType();
  const [sort, setSort] = useState<EFileSort>(EFileSort.New);

  const query = useMemo(() => getQuery(sort), [sort]);

  useFetchInfoTypesService("Hospitalizations", query);

  return (
    <WrapperCardList space={16}>
      <CustomSpaceList>
        <KSemiText700>Hospitalizations</KSemiText700>
        <SortItem sort={sort} setSort={setSort} />
        {isLoadingList ? <Loading /> : renderCardItems(hospitalizationsList)}
      </CustomSpaceList>
    </WrapperCardList>
  );
};
